module.exports = __webpack_public_path__ + "static/media/sandglass.c1ba0aa5.svg";